<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CyFE1x/images/cover.jpg?1684274657104" alt="This image is the cover for the book Discipleship in Community"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Discipleship in Community
      </h1>
      <p class="bookDescription body article font2">
        <p>Jesus said, “Go and make disciples.” So, what exactly are we doing? <br/><br/>Western churches face a difficult future marked by numerical decline and evident signs of shrinking cultural influence. But <i>Discipleship in Community</i> wisely asks the church to go back to basics. What does it mean to follow Jesus? What does a life of discipleship look like? <br/><br/>Trusted scholars <b>Mark Powell</b>, <b>John Mark Hicks</b>, and <b>Greg McKinzie</b> invite you to consider how good theology can lead to better, more intentional discipleship. In <i>Discipleship in Community</i> you will learn <br/>• how the language of Trinity matters to everyday disciples; <br/>• how God’s plan and mission is unfolding and how, as disciples, we can participate in that mission; <br/>• how the Bible is more than a book of facts and how it guides us into a relationship with God; <br/>• how baptism and the Lord’s Supper allow us to experience God’s saving power; and <br/>• how local churches can encourage intentional discipleship.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark E. Powell, John Mark Hicks, Greg McKinzie
      </h2>
      
      <p class="authorDescription body article"><b>MARK E. POWELL</b> is a professor of theology at Harding School of Theology in Memphis, Tennessee, and the author of <i>Centered in God</i>. <b>JOHN MARK HICKS</b> is a professor of theology at Lipscomb University in Nashville, Tennessee. He is the author of six books, including <i>Meeting God at the Shack</i>. <b>GREG MCKINZIE</b> is the executive editor of <i>Missio Dei</i>, an online journal for missions, theology, and practice.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      ACU Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?54e673e1